<!-- Page Content -->
<div class="min-h-screen bg-gray-50">
  <router-outlet></router-outlet>
</div>
